<div class="modal-header">
  <h4 class="modal-title">
    {{ isEdit ? 'Edit tooltip' : 'New tooltip' }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="form-group">
    <label for="header">Header <span class="text-danger">*</span></label>
    <input
      type="text"
      class="form-control"
      id="header"
      [(ngModel)]="header"
      placeholder="e.g. Help">
  </div>

  <div class="form-group">
    <label for="text">Text <span class="text-danger">*</span></label>
    <textarea
      class="form-control"
      id="text"
      [(ngModel)]="text"
      rows="4"
    placeholder="Describe the feature..."></textarea>
  </div>

  <div class="form-group">
    <label for="position">Tooltip Position</label>
    <select class="form-control" id="position" [(ngModel)]="position" (ngModelChange)="onPositionChange()">
      @for (opt of positionOptions; track opt) {
        <option data-tooltip-no-anchor [value]="opt.value">
          {{ opt.label }}
        </option>
      }
    </select>
  </div>

  <div class="form-group">
    <label for="tooltipAlign">Tooltip Alignment</label>
    <select class="form-control" id="tooltipAlign" [(ngModel)]="tooltipAlign">
      @for (opt of tooltipAlignOptions; track opt) {
        <option data-tooltip-no-anchor [value]="opt.value">
          {{ opt.label }}
        </option>
      }
    </select>
    <small class="form-text text-muted">
      Alignment of tooltip relative to target element
    </small>
  </div>

  <div class="form-group">
    <label for="iconPlacementMode">Icon Placement Mode</label>
    <select id="iconPlacementMode" class="form-control" [(ngModel)]="iconPlacementMode">
      <option [value]="TooltipIconMode.Positioned">Positioned (absolute)</option>
      <option [value]="TooltipIconMode.Inline">Inline (next to element)</option>
    </select>
    <small class="form-text text-muted">
      Positioned: Icon floats over page. Inline: Icon appears in DOM flow
    </small>
  </div>

  <div class="form-group">
    <label for="iconPlacement">Icon placement</label>
    <select id="iconPlacement" class="form-control" [(ngModel)]="iconPlacement" (ngModelChange)="onPlacementChange()">
      @for (option of iconPlacementOptions; track option) {
        <option data-tooltip-no-anchor [value]="option.value">{{ option.label }}</option>
      }
    </select>
  </div>

  <div class="form-group">
    <label for="iconAlign">Icon alignment</label>
    <select id="iconAlign" class="form-control" [(ngModel)]="iconAlign">
      @for (option of iconAlignOptions; track option) {
        <option data-tooltip-no-anchor [value]="option.value">{{ option.label }}</option>
      }
    </select>
  </div>

  <div class="form-group">
    <label for="iconRotation">Icon rotation</label>
    <select class="form-control" id="iconRotation" [(ngModel)]="iconRotation">
      @for (value of iconRotationOptions; track value) {
        <option data-tooltip-no-anchor [ngValue]="value">
          {{ value }}&deg;
        </option>
      }
    </select>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label for="iconOffsetTop">Icon Offset Top (px)</label>
        <input
          type="number"
          class="form-control"
          id="iconOffsetTop"
          [(ngModel)]="iconOffsetTop"
          placeholder="0">
        <small class="form-text text-muted">Icon vertical offset (relative)</small>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label for="iconOffsetLeft">Icon Offset Left (px)</label>
        <input
          type="number"
          class="form-control"
          id="iconOffsetLeft"
          [(ngModel)]="iconOffsetLeft"
          placeholder="0">
        <small class="form-text text-muted">Icon horizontal offset (relative)</small>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">
    Cancel
  </button>
  <button type="button" class="btn btn-success" (click)="save()">
    {{ isEdit ? 'Update' : 'Create' }}
  </button>
</div>
